import Constant from '@/const';
import axios from 'axios';

const postLabRequest = async payload => {
  try {
    const response = await axios.post(
      Constant.apiUrl.concat(`/supportservice/laboratory/request`),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default postLabRequest;
